import { Fragment } from "react";
import { Icons } from "@/components/Icons";
import NotificationDot from "@/components/NotificationDot";
import { usePrefs } from "@/lib/prefs";
import { AvatarMenu } from "./AvatarMenu";
import { OrgSwitcher } from "./OrgSwitcher";

export function TopBar({ crumbs, onNotif, onCmd, onHelp }: {
  crumbs: string[];
  onNotif: () => void;
  onCmd: () => void;
  onHelp: () => void;
}) {
  const { prefs, toggleTheme } = usePrefs();
  return (
    <div className="topbar">
      <div className="crumbs">
        {crumbs.map((c, i) => (
          <Fragment key={i}>
            {i > 0 && <span className="sep"><Icons.ChevRight size={12} /></span>}
            <span className={i === crumbs.length - 1 ? "current" : ""}>{c}</span>
          </Fragment>
        ))}
      </div>
      <div className="search" data-tour="search" onClick={onCmd}>
        <span className="si"><Icons.Search size={15} /></span>
        <input placeholder="Search or jump to…  ⌘K" readOnly style={{ cursor: "text" }} />
      </div>
      <div className="actions">
        <button className="icon-btn" onClick={onCmd} title="Search (⌘K)" aria-label="Search"><Icons.Search size={18} /></button>
        <button className="icon-btn" onClick={toggleTheme} title="Theme" aria-label="Toggle theme">
          {prefs.theme === "dark" ? <Icons.Sun size={18} /> : <Icons.Moon size={18} />}
        </button>
        <button className="icon-btn" onClick={onHelp} title="Help for this page (?)" aria-label="Help"><Icons.Help size={18} /></button>
        <button className="icon-btn" onClick={onNotif} title="Notifications" aria-label="Notifications" data-tour="notifications">
          <Icons.Bell size={18} /><NotificationDot />
        </button>
        <OrgSwitcher />
        <AvatarMenu />
      </div>
    </div>
  );
}
